import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/star-large.svg'


const _withScopeId = n => (_pushScopeId("data-v-2294e703"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-favorite",
  src: _imports_0,
  "aria-hidden": "true",
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "detail" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_6 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["no-favorite-container", { 'hide-border': $props.shouldHideBorder }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("em", null, "즐겨찾는 " + _toDisplayString($setup.favoriteTypeLabel) + "이 없습니다.", 1 /* TEXT */),
        _hoisted_4,
        _createTextVNode(" 자주 이용하는 " + _toDisplayString($setup.favoriteTypeLabel) + "을 추가하고", 1 /* TEXT */),
        _hoisted_5,
        _createTextVNode(" 더 편리하게 이용하세요! ")
      ]),
      _createElementVNode("button", {
        class: "btn-search",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickSearch'))),
        "aria-label": `${$setup.favoriteTypeLabel} 검색하기`
      }, [
        _createVNode($setup["InlineSvg"], {
          src: require('@/assets/icons/search.svg'),
          "aria-hidden": "true",
          alt: ""
        }, null, 8 /* PROPS */, ["src"]),
        _createElementVNode("p", null, _toDisplayString($setup.favoriteTypeLabel) + " 검색하기", 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_6)
    ])
  ], 2 /* CLASS */))
}